import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';
import {
  isAuthenticated,
  isCompanySelected,
  getSelectedCompanyType,
} from '../store/selectors/AuthSelectors';

// `allowedCompanyTypes` (optional): array of canonical Pascal-case Swedish
// company types (e.g. ['Aktiebolag', 'Handelsbolag']) — when present, the
// route is only rendered if the selected company's `companyType` is in
// this list. Mismatches redirect to /select-company. Undefined preserves
// today's behavior (every authenticated tenant is allowed).
//
// Source-of-truth for valid values: src/constants/companyTypes.js
export const CompanyRoute = ({ component: Component, allowedCompanyTypes, ...rest }) => {
  const userIsAuthenticated = useSelector(isAuthenticated);
  const companyIsSelected = useSelector(isCompanySelected);
  const selectedCompanyType = useSelector(getSelectedCompanyType);

  if (!userIsAuthenticated) {
    return (
      <Redirect
        to={{
          pathname: '/login',
          state: { from: rest.location }
        }}
      />
    );
  }

  if (!companyIsSelected) {
    console.log('Company not selected, redirecting to company selection');
    return <Redirect to="/select-company" />;
  }

  if (Array.isArray(allowedCompanyTypes) && allowedCompanyTypes.length > 0) {
    if (!allowedCompanyTypes.includes(selectedCompanyType)) {
      return <Redirect to="/select-company" />;
    }
  }

  return (
    <Route
      {...rest}
      render={(props) => <Component {...props} />}
    />
  );
};
